/**
 * Countdown timer for product drops and events.
 *
 * On any [data-countdown] element:
 *   data-deadline="YYYY-MM-DD HH:MM" or "YYYY-MM-DD" — target time (store local time)
 *   data-expired="message" | "hide"                  — behavior once the deadline passes
 *
 * Fills [data-unit="days|hours|minutes|seconds"] every second and, on expiry,
 * either reveals the [data-countdown-expired] message or hides the whole widget.
 */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function parseDeadline(raw) {
    if (!raw) return null;
    var str = String(raw).trim();
    if (!str) return null;

    /* "YYYY-MM-DD HH:MM" -> "YYYY-MM-DDTHH:MM" for local-time parsing */
    var iso = str.replace(' ', 'T');
    var d = new Date(iso);
    if (isNaN(d.getTime())) {
      d = new Date(Date.parse(str));
    }
    return isNaN(d.getTime()) ? null : d;
  }

  function init(el) {
    if (el.__countdownInit) return;
    el.__countdownInit = true;

    var deadline = parseDeadline(el.getAttribute('data-deadline'));
    if (!deadline) return;

    var deadlineMs = deadline.getTime();
    var behavior = el.getAttribute('data-expired') || 'message';

    var tiles = el.querySelector('[data-countdown-tiles]');
    var expiredEl = el.querySelector('[data-countdown-expired]');

    var cells = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      minutes: el.querySelector('[data-unit="minutes"]'),
      seconds: el.querySelector('[data-unit="seconds"]')
    };

    var timer = null;

    function expire() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (behavior === 'hide') {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
        /* Reveal an external expired message next to the widget, if any.
           Guard: never reach into a different [data-countdown] element
           (e.g. neighboring cards in a grid of independent countdowns). */
        var sibling = el.parentNode ? el.parentNode.querySelector('[data-countdown-expired]') : null;
        if (sibling && sibling !== expiredEl && !sibling.closest('[data-countdown]')) {
          sibling.removeAttribute('hidden');
        }
      } else {
        if (tiles) tiles.setAttribute('hidden', '');
      }
      if (expiredEl) expiredEl.removeAttribute('hidden');
    }

    function tick() {
      var remaining = deadlineMs - Date.now();
      if (remaining <= 0) {
        expire();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (cells.days) cells.days.textContent = days;
      if (cells.hours) cells.hours.textContent = pad(hours);
      if (cells.minutes) cells.minutes.textContent = pad(minutes);
      if (cells.seconds) cells.seconds.textContent = pad(seconds);
    }

    tick();
    if (deadlineMs - Date.now() > 0) {
      timer = setInterval(tick, 1000);
    }
  }

  function ready() {
    var els = document.querySelectorAll('[data-countdown]');
    Array.prototype.forEach.call(els, init);
  }

  if (document.readyState !== 'loading') {
    ready();
  } else {
    document.addEventListener('DOMContentLoaded', ready);
  }

  /* Pick up countdowns in sections added/re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', ready);
})();
